module.exports = __webpack_public_path__ + "media/src/images/buttons/white-au-5058dbe897e6adce3bc0a69a79bd004b.svg";